var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg30",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2",
    type: "text/css"
  }, "\n    .st0{opacity:.2;fill:none;stroke:#000;stroke-width:5.000000e-02;stroke-miterlimit:10}\n  ")), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "M12 2c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1s1-.4 1-1V3c0-.6-.4-1-1-1Z",
    style: {
      fill: "var(--primary-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M12 17c-.5 0-1 .4-1 1v3c0 .6.4 1 1 1 .5 0 1-.4 1-1v-3c0-.5-.5-1-1-1z",
    style: {
      fill: "var(--primary-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path445",
    d: "M22 12c0-.6-.4-1-1-1h-3c-.6 0-1 .4-1 1s.4 1 1 1h3c.6 0 1-.4 1-1z",
    style: {
      fill: "var(--primary-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path447",
    d: "M7 12c0-.5-.4-1-1-1H3c-.6 0-1 .4-1 1 0 .5.4 1 1 1h3c.5 0 1-.5 1-1z",
    style: {
      fill: "var(--primary-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path449",
    d: "M20.660254 17c.3-.519615.15359-1.066025-.366025-1.366025l-2.598077-1.5c-.519615-.3-1.066025-.15359-1.366025.366025-.3.519615-.15359 1.066025.366025 1.366025l2.598077 1.5c.519615.3 1.066025.15359 1.366025-.366025z",
    style: {
      fill: "var(--primary-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path451",
    d: "M7.669873 9.5c.25-.4330127.1535898-1.0660254-.3660254-1.3660254l-2.5980762-1.5c-.5196153-.3-1.0660254-.1535898-1.3660254.3660254-.25.4330127-.1535899 1.0660254.3660254 1.3660254l2.5980762 1.5C6.7368603 10.116025 7.419873 9.9330127 7.669873 9.5Z",
    style: {
      fill: "var(--primary-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path453",
    d: "M17.001487 20.654705c.519615-.3.666025-.84641.366025-1.366025l-1.5-2.598076c-.3-.519616-.84641-.666026-1.366025-.366026s-.666026.84641-.366026 1.366025l1.500001 2.598076c.3.519616.84641.666026 1.366025.366026z",
    style: {
      fill: "var(--primary-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path457",
    d: "M7.0061988 20.646544c.5196151.3 1.0660251.15359 1.3660249-.366026l1.4999998-2.598076c.3000005-.519615.1535905-1.066025-.3660247-1.366025-.5196151-.3-1.0660256-.15359-1.3660254.366025l-1.4999993 2.598077c-.3000006.519615-.1535904 1.066025.3660247 1.366025z",
    style: {
      fill: "var(--primary-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path459",
    d: "M14.506199 7.6561627c.433012.25 1.066025.1535897 1.366025-.3660254l1.5-2.5980762c.3-.5196152.15359-1.0660254-.366025-1.3660254-.433013-.25-1.066026-.1535899-1.366026.3660254l-1.5 2.5980762c-.249999.4330127-.06699 1.1160254.366026 1.3660254z",
    style: {
      fill: "var(--primary-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path461",
    d: "M3.3514937 16.987777c.2999999.519615.8464099.666025 1.3660253.366024l2.5980759-1.5c.5196156-.299999.6660258-.846409.3660259-1.366024-.2999999-.519615-.8464103-.666026-1.3660252-.366026l-2.598076 1.500001c-.5196157.3-.6660257.84641-.3660259 1.366025z",
    style: {
      fill: "var(--primary-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path463",
    d: "M16.341875 9.4877767c.249999.4330123.84641.6660253 1.366025.3660252l2.598076-1.5c.519616-.3.666026-.8464101.366026-1.3660252-.25-.4330129-.846411-.6660258-1.366026-.3660257l-2.598076 1.5c-.433012.2500005-.616028.9330113-.366025 1.3660257z",
    style: {
      fill: "var(--primary-color)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.b93e8f257b02c6d2789bc321a01ec438.svg";
export { ForwardRef as ReactComponent };